export const options = {
  paging: true,
  autoWidth: true,
  order: [[0, "asc"]],
  columnDefs: [{ targets: "_all", orderable: true }],
  pagingType: "simple_numbers",
  scrollY: "50vh",
  scrollCollapse: true,
  language: {
    lengthMenu: "Show _MENU_ entries",
    paginate: {
      next: "Next",
      previous: "Previous",
    },
    info: "Showing _START_ to _END_ of _TOTAL_ entries",
  },
  dom:
    "<'row'<'col-sm-12 col-md-6' l><'col-sm-12 col-md-6 mb-2'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 d-flex justify-content-end'p>>",
};

export const columns = [
  { title: "Number", data: "number" },
  { title: "Name", data: "name" },
  { title: "Hole", data: "hole" },
  { title: "Colour", data: "colour" },
  { title: "Colour Hex", data: "colourHex" },
];
